export default __webpack_public_path__ + "media/images/svg/diagonal_arrow-53f789fe8a3e7c45ca3e8a993c79c901.svg";